var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{style:({ color: _vm.color })},[_c('v-icon',{attrs:{"small":"","color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm._f("percentage")(_vm.evolutionPercentage,0))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }